import React, { useState } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import Link from 'react-router-dom/Link';

const LandWellsTable = ({ Land }) => {
  const [highlightedRowID, setHighlightedRow] = useState(null);
  const commonWidth = '15%'
  const commonHeight = '30px'
  const columns = [
    {
      title: 'ID',
      field: 'id',
      cellStyle: {
        width: commonWidth,
        height: commonHeight,
        overflow: 'auto',
      },
      render: (rowData) => (
        <Link to={`/Wells/${rowData.id}?name=${encodeURIComponent(rowData.name)}`}>
          {rowData.name}
        </Link>
      ),
    },
    {
      title: 'Operator',
      field: 'drilledOn',
      cellStyle: {
        width: commonWidth,
        height: commonHeight,
        overflow: 'auto',
      },
      render: (rowData) => rowData.drilledOn.map((w) => w.id).join(', '),
    },
    {
      title: 'Status',
      field: 'status',
      cellStyle: {
        width: commonWidth,
        height: commonHeight,
        overflow: 'auto',
      },
    },
  ];
  const pageLength = Land.rowsOn.length;
  return (
    <MaterialTable
      title=""
      columns={columns}
      data={Land.drilledOn.map(d => ({ ...d }))}
      options={{
        paging: false,
        search: false,
        pageSize: pageLength,
        // maxBodyHeight: 'calc(100vh - 150px)',
        // // searchFieldAlignment: 'left',
        // // searchFieldStyle: {
        // //   backgroundColor: '#fff',
        // //   color: '#000',
        // //   border: 'none',
        // //   padding: '4px 8px',
        // //   borderRadius: '4px',
        // // },
        showTitle: false,
        // toolbarButtonAlignment: 'left',
        // addRowPosition: 'first',
        exportButton: false,
        headerStyle: {
          backgroundColor: '#1976d2',
          color: '#FFF',
          textAlign: 'left',
          justifyContent: 'center',
          whiteSpace: 'pre',
        },
      }}
      components={{
        Toolbar: (props) => (
          <div
            style={{
              height: 16,
              width:"100%",
              marginTop: -30,
              backgroundColor: '#1976d2',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 20,
            }}
          >
            <MTableToolbar {...props} />
          </div>
        ),
      }}
    />
  );
};

export default LandWellsTable;
